import {$, w} from './constants';
import { initializeHomeSlider, sliderGrab, sameHeightSlides, initializeTestimonialsSlider, sameHeightSliders, initializeAFASSlider, initializeSliderAdvisory, initializeFaqsSlider } from './sliders.js';
import { playVideo, playVideoHero, viewerVideo, videoYT } from './video.js';
import { calc } from './calc.js';
import { calcRetirement } from './calc-retirement.js';
import { calcPPR } from './ppr.js';
import { audioPlayer } from './audio-player.js';
import { chatbot } from './chatbot.js';
import { simulador } from './simulador.js';
import { tableControls } from './table-controls.js';
import { tableSort } from './table-sort.js';
import { advisoryForm } from './advisory-form.js';
import { blockScroll } from './blockScroll.js';
import { calculatorAFAS } from './calculator_afas.js';
import { fondos, avisos } from './documents.js';
import { fondo } from './fondo.js';
import { topPicksGrid } from './top-picks-grid.js';
import {faqs} from './faqs.js';
import './utm.js';
import './fondos_externos.js';
import './calendar.js';
import './calculator-ppr.js';
import './research_filters.js';
import './antifraude.js';
import './ctas_global.js';
import './app.js';
import { addAppFlagToLinks } from './app';
import './home_media.js';
import './legal.js';
import { initResponsiveLinkTargets } from './analytics-ctas.js';

w.load(() => {
	console.log('Hello world from El Cultivo! --Load');
	if( $('.home_slider').length){
		initializeHomeSlider( '.home_slider', 951 );
	}
	if( $('#video_src').length){
		playVideo();
	}
	if( $('.video_hero_src').length){
		playVideoHero();
	}
	if( $('.js-youtube-player-wrap').length){
		videoYT();
	}
	sliderGrab();
	advisoryForm();
	blockScroll();
	topPicksGrid();
	if( $('.slider_testimonials').length ){
		initializeTestimonialsSlider($('.slider_testimonials'));
	}

	//Blog AFAS
	if( $('.afas-blog-archive__featured').length ){
		adjustFeaturedHeight();
	}

	if( $('#slider_height').length ){
		sameHeightSlides($('#slider_height'));
	}

	if( $('.sliders_height').length ){
		sameHeightSliders($('.sliders_height'));
	}
	
	//Popup Trading
	$('.open_pop_card').on('click', function(){
		let index = $(this).data('index-pop');
		$(`.pop_card[data-index-pop="${index}"]`).fadeIn(300);
	});
	$('.trading-template__updates-cards-pop-close').on('click', function(){
		$(this).parent().parent().parent().fadeOut(150);
	});

	/* C O O K I E S */
	if(localStorage.getItem('gbm_cookie')){
		$('#cookies_gbm').addClass('hide');
	}else{
		$('#cookies_gbm').delay(1000).fadeIn(100);

		$('#cookies_gbm_accept').click(() => {
			localStorage.setItem('gbm_cookie', 'true');
			$('#cookies_gbm').fadeOut(100).addClass('hide');
			$('#cookies_gbm').delay(1000).removeClass('show');
		})
	}
	/* END: C O O K I E S */

	//AFAS Blog
	if( $('#slider_blog_afas').length ){
		initializeAFASSlider('#slider_blog_afas');
	}

	//Research Home
	if( $('#research-home_slider').length){
		initializeHomeSlider( $('#research-home_slider'), 951 );
	}
	
	//Advisory v2 Slider
    if( $('#slider_advisory').length ){
        initializeSliderAdvisory($('#slider_advisory'));
    }

	//FAQs
	if( $('#faqs_slider').length ){
		initializeFaqsSlider($('#faqs_slider'));
	}

	//Campañas
	if( $('.slider_height_campaign').length ){
		sameHeightSliders($('.slider_height_campaign'));
	}

})


$(document).scroll(function() {
	blockScroll();
})


$(document).ready(function() {

	console.log('Hello world from El Cultivo! --Ready')
	advisoryForm();
	initResponsiveLinkTargets();

	// Retirement Calculator init
	if ($('.calc_ret_JS').length) {
		calcRetirement()
		$('.calc_ret_JS').find('.graph_input_JS.int').each(function(){
			$(this).val(($(this).val()).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))
			$(this).closest('div').addClass('active').removeClass('error')
		})
	}

	if ($('.calc_ppr_JS').length) {
		calcPPR()
	}

	// Compound Interest Calculator init
	if ($('.calc_JS').length) {
		calc()
	}

	// Calculator Select
	$('.calc_select_JS').on('change', function () {
		var calc = $('.calc_select_JS').val()
		$('.calc_item_JS').each(function () {
			if ($(this).hasClass(calc)) {
				$(this).fadeIn(0, function() {
					if ($(this).hasClass('calc_retirement_JS')) {
						calcRetirement();
						if (window.chart) {
							window.chart.flush();
							window.chart.resize();
						}
					}
				})
			} else {
				$(this).hide()
			}
		})
	})

	const nav = $(".header");
	/* M E N U: Scroll */
	w.scroll(function (event) {
		if($(this).scrollTop() > 0){
			$('.menu-item-has-children').removeClass('active');
		}
	});
	$('.menu-item-has-children').click(function(e){
		console.log('Log para click')
		e.preventDefault();
		e.stopPropagation();
		// Cierra todos los submenús excepto el actual
		$('.menu-item-has-children').not(this).removeClass('active');
		$(this).toggleClass('active');
	});
	$('.sub-menu').click(function(e){
		e.stopPropagation();
	});
	$('#open_menu').on('click', function(e){
		$('#header_mobile').fadeIn(200);
	});
	$('#close_menu').on('click', function(e){
		$('#header_mobile').fadeOut(100);
	});

	// Footer
	if($('.menu-item.footer_mobile_link').length ){
		updateFooterLogin();
	}

	//Toggle Galería
	if( $('#gallery_markets').length){
		$('div[data-index]').on('click', toggleGallery);
		if ($(w).width() > 951) {
			$('div[data-index]').on('mouseenter', toggleGallery);
		}
	}

	//Toggle Información
	if ($('#information_toggle').length) {
		toggleCard($('#information_toggle'));
	}
	
	//Toggle Personas
	if( $('#people_toggle').length ){
		if ($(w).width() > 951) {
			$('.columns_module_toggle .grid.grid--col-2-people').each(function() {
				setEqualHeight(this);
			});
		}
		$('.toggle_simple_trigger').on('click', function(event){
			event.preventDefault(); 
			event.stopPropagation();
		
			$(this).toggleClass('active');
			$(this).siblings('.toggle_simple_target').slideToggle(300);
		});
	}

	//Calculadora AFAS
	if( $('#calculator_afas').length ){
		calculatorAFAS();
	}

	//Directorio AFAS
	$('.block_afa_trigger').on('click', function(){
		$(this).toggleClass('active');
		$(this).siblings('.block_afa_target').slideToggle(300);
	});

	// Buscar cuando se presiona una tecla en el campo de búsqueda
	$('.search-input').on('keyup', function() {
		let search_term = $(this).val();
		let state_filter = $('.select-field select').val();
		fetch_afas(search_term, state_filter);
	});

	// Filtrar cuando se selecciona un estado
	$('.select-field select').on('change', function() {
		let search_term = $('.search-input').val();
		let state_filter = $(this).val();
		fetch_afas(search_term, state_filter);
	});

	//Login
	/* const loginButton = $('#wp-submit');
	if (loginButton.length) {
		console.log('Inicia sesión')
		loginButton.append('<span class="arrow"></span>');
	} */

	//Pop Up Footer
	$('.pop_up_footer > a').on('click', function(e) {
		e.preventDefault();
		e.stopPropagation();
		$('#pop_up_footer').fadeIn(300);
	});
	
	$('.footer__pop-close').on('click', function(e) {
		$(this).parent().parent().parent().fadeOut(150);
	});

	$('.pop_up_footer_2 > a').on('click', function(e) {
		e.preventDefault();
		e.stopPropagation();
		$('#pop_up_footer_2').fadeIn(300);
	});
	
	//Fondos de Información
	if( $('#fondos_container').length ){
		fondos();
	}

	if( $('#avisos_container').length ){
		avisos();
	}

	//AFAS Blog
	if( $('#archive_afas').length){
		cargarArticulos(tipoActivo, 1);
	}

	if($('#faqs-search-input').length){
		faqs();
	}
	viewerVideo();

	//Research Profiles
	$('.profile_btn_JS').click(function () {
		let id = $(this).attr('id')
		$('.profile_card_JS#'+id).fadeIn('fast')
	})
	$('.profile_close_JS').click(function () {
		$('.profile_card_JS').fadeOut('fast')
	})

	//Advisory Explore
	$('.advisory_explore_btn_JS').click(function () {
		let item = $(this).data('item')
		$('.advisory_explore_btn_JS').removeClass('active')
		$(this).addClass('active')
		$('.advisory_explore_item_JS').hide()
		$('.advisory_explore_item_JS').removeClass('active')
		$('.advisory_explore_item_JS[data-item="'+item+'"]').fadeIn()
	})

	//Advisory: Allow dragging for scrolls
	function enableDragScroll(slider, options = {}) {
		let isDragging = false;
		let startX;
		let startY;
		let scrollLeft;
		let scrollTop;
		slider.addEventListener('pointerdown', (e) => {
			if (e.button !== 0) return;
			if (e.target.closest('a')) return;
			if (options.breakpoint && window.innerWidth > options.breakpoint) return;
			isDragging = true;
			slider.setPointerCapture(e.pointerId);
			startX = e.clientX;
			startY = e.clientY;
			scrollLeft = slider.scrollLeft;
			scrollTop = slider.scrollTop;
		});
		slider.addEventListener('pointermove', (e) => {
			if (!isDragging) return;
			e.preventDefault();
			slider.scrollLeft = scrollLeft - (e.clientX - startX);
			slider.scrollTop = scrollTop - (e.clientY - startY);
		});
		slider.addEventListener('pointerup', () => {
			isDragging = false;
		});
		slider.addEventListener('pointercancel', () => {
			isDragging = false;
		});
	}
	// Always draggable
	document.querySelectorAll('.advisory_scroll_JS').forEach((el) => {
		enableDragScroll(el);
	});
	// Draggable under 950px
	document.querySelectorAll('.advisory_scroll_sm_JS').forEach((el) => {
		enableDragScroll(el, { breakpoint: 950 });
	});



});



// Toogle Servicios
$('.dropdown_trigger').on('click', function(){
	if( $(w).width() < 951 ){
		$(this).toggleClass('active');
		$(this).siblings('.dropdown_target').slideToggle(300);
	}
});

// Toogle Institucional
$('.toogle_column_mobile').on('click', function(){
	if( $(w).width() < 951 ){
		$(this).toggleClass('active');
		$(this).siblings('.toogle_column_mobile_target').slideToggle(300);
	}
});

// Toogle Fondos Información
$('.fondo_trigger').on('click', function() {
	if ($(window).width() < 951) {
	  $('.fondo_trigger').not(this).removeClass('active');
	  $('.fondo_target').not($(this).siblings('.fondo_target')).slideUp(300);

	  $(this).toggleClass('active');
	  $(this).siblings('.fondo_target').slideToggle(300);
	}
});

// Toogle Asset
$('.dropdown_philosophy_trigger').on('click', function(){
	$(this).toggleClass('active');
	$(this).siblings('.dropdown_philosophy_target').slideToggle(300);
});

// Current Reseach company
if ($('.current_JS').length) {
	$('.current_JS').each(function () {
		$(this).closest('.list_block_JS').find('.trigger_research_sector').addClass('active')
		$(this).closest('.list_block_JS').find('.target_research_sector').slideDown('fast')
		if ($(this).hasClass('subcompany-item')) {
			$(this).closest('.list_block_JS').find('.trigger_research_subsector').addClass('active')
			$(this).closest('.list_block_JS').find('.subcompanies_list').slideDown('fast')
			$(this).closest('li').parent().closest('li').addClass('current')
		}
	})
}

//Toggle Research
$('.trigger_research_sector').on('click', function(){
	$('.trigger_research_sector').not(this).removeClass('active');
	$('.target_research_sector').not($(this).siblings('.target_research_sector')).slideUp(300);
	$(this).toggleClass('active');
	$(this).siblings('.target_research_sector').slideToggle(300);
});
$('.trigger_research_subsector').on('click', function(){
	$(this).toggleClass('active');
	$(this).closest('li').find('.subcompanies_list').slideToggle(300);
});
$('#open_sectors_menu').on('click', function(){
	$('#sectors_menu').fadeIn(300);
});
$('#close_sectors_menu').on('click', function(){
	$('#sectors_menu').fadeOut(150)
});

// Toogle Trading
$('.trigger_trading_tab').on('click', function() {
	$('.trigger_trading_tab').not(this).removeClass('active');
	$('.target_trading_tab').not($(this).siblings('.target_trading_tab')).slideUp(300);

	$(this).toggleClass('active');
	$(this).siblings('.target_trading_tab').slideToggle(300);
});

// Página Inversiones Alternativas
$('.dropdown_value_trigger').on('click', function() {
	$('.dropdown_value_trigger').not(this).removeClass('active');
	$('.dropdown_value_target').not($(this).siblings('.dropdown_value_target')).slideUp(300);

	$(this).toggleClass('active');
	$(this).siblings('.dropdown_value_target').slideToggle(300);
});

function igualarAlturasInvestmentBlocks() {
	var maxHeight = 0;

	// Resetear alturas
	$('.investments-template__block-investments-single').css('height', 'auto');

	// Calcular la altura máxima
	$('.investments-template__block-investments-single').each(function () {
		var thisHeight = $(this).outerHeight();
		if (thisHeight > maxHeight) {
			maxHeight = thisHeight;
		}
	});

	// Asignar altura máxima
	$('.investments-template__block-investments-single').css('height', maxHeight + 'px');
}
$(document).ready(function () {
	if( $('.investments-template__block-investments-single').length ){
		igualarAlturasInvestmentBlocks();
	}
});
$(window).on('resize', function () {
	if( $('.investments-template__block-investments-single').length ){
		igualarAlturasInvestmentBlocks();
	}
});

function updateFooterLogin() {
	const $footerLink = $('.menu-item.footer_mobile_link > a');

	// Guarda la URL original en el atributo `data-original-link` si aún no está configurada
	if (!$footerLink.data('original-link')) {
		const originalLink = $footerLink.attr('href');
		$footerLink.attr('data-original-link', originalLink);
		$footerLink.data('original-link', originalLink);
	}

	const originalLink = $footerLink.data('original-link'); // URL original del escritorio
	const mobileLink = $footerLink.attr('title');		   // URL para móvil
	const idFooter = ['click_footer_abrir-cuenta_desk', 'click_footer_abrir-cuenta_mobile'];

	if ($(window).width() < 951) {
		$footerLink.attr('href', mobileLink);
		$footerLink.attr('id', idFooter[1]);
	} else {
		$footerLink.attr('href', originalLink);
		$footerLink.attr('id', idFooter[0]);
	}
}


//Blog AFAS
function adjustFeaturedHeight() {
	let opinionHeight = $('.afas-blog-archive__featured-opinions').outerHeight();
	let featuredArticle = $('.afas-blog-archive__featured-card');
	let featuredImageContainer = $('.afas-blog-archive__featured-card .image-container');
	let featuredContent = $('.afas-blog-archive__featured-card .data-container');
	
	let initialFeaturedHeight = featuredArticle.outerHeight();

	if (opinionHeight > initialFeaturedHeight) {
		let contentHeight = featuredContent.outerHeight();
		let newImageHeight = opinionHeight - contentHeight;

		featuredImageContainer.css('min-height', newImageHeight + 'px');
	} else {
		featuredImageContainer.css('min-height', '');
	}
}

$(window).on('resize', function() {
	if( $('.afas-blog-archive__featured').length ){
		adjustFeaturedHeight();
	}

	// Footer
	if($('.menu-item.footer_mobile_link').length ){
		updateFooterLogin();
	}
});

let current_page = 1;
let current_page_mobile = 1;

//Paginador Opinions
$('#btn_opinion_prev').on('click', function(){
	if( current_page > 1 ){
		current_page-=1;
		fetch_opinion( current_page, 3 );
	}else{
		$(this).addClass('disabled');
	}
});
$('#btn_opinion_next').on('click', function(){
	if( current_page == $('#max_pages').val()){
		$(this).addClass('disabled');
	}else{
		current_page+=1;
		fetch_opinion( current_page, 3 );
	}
});
$('.btn_opinion_page').on('click', function(){
	$('.page-numbers').removeClass('current');
	$(this).addClass('current');
	let page = $(this).data('page');
	current_page = page;
	fetch_opinion( current_page, 3 );
});
$('#btn_opinion_prev_mobile').on('click', function(){
	if( current_page_mobile > 1 ){
		current_page_mobile-=1;
		fetch_opinion_mobile( current_page_mobile , 1 );
	}else{
		$(this).addClass('disabled');
	}
});
$('#btn_opinion_next_mobile').on('click', function(){
	if( current_page_mobile == $('#max_pages_mobile').val()){
		$(this).addClass('disabled');
	}else{
		current_page_mobile+=1;
		fetch_opinion_mobile( current_page_mobile, 1 );
	}
});

const fetch_opinion = (page, size) => {
	$.ajax({
		type: 'POST',
		dataType: 'html',
		url: cltvo_js_vars.ajax_url,
		data: { 
			action : 'load_opinion', 
			page: page,
			size: size
		},
		success: function(data){
			$('#opinion_grid').empty();
			$('#opinion_grid').html(data);
			if( current_page == $('#max_pages').val()){
				$('#btn_opinion_next').addClass('disabled');
			}else{
				$('#btn_opinion_next').removeClass('disabled');
			}
			if( current_page == 1){
				$('#btn_opinion_prev').addClass('disabled');
			}else{
				$('#btn_opinion_prev').removeClass('disabled');
			}
		},
		error: function(errors){
			console.log( errors );
		}
	});
}

const fetch_opinion_mobile = (page, size) => {
	$.ajax({
		type: 'POST',
		dataType: 'html',
		url: cltvo_js_vars.ajax_url,
		data: { 
			action : 'load_opinion', 
			page: page,
			size: size
		},
		success: function(data){
			$('#opinion_grid_mobile').empty();
			$('#opinion_grid_mobile').html(data);
			if( current_page_mobile == $('#max_pages_mobile').val()){
				$('#btn_opinion_next_mobile').addClass('disabled');
			}else{
				$('#btn_opinion_next_mobile').removeClass('disabled');
			}
			if( current_page_mobile == 1){
				$('#btn_opinion_prev_mobile').addClass('disabled');
			}else{
				$('#btn_opinion_prev_mobile').removeClass('disabled');
			}
		},
		error: function(errors){
			console.log( errors );
		}
	});
}

$(w).on('resize', function(){
	if( $('#slider_height').length ){
		sameHeightSlides($('#slider_height'));
	}

	if( $('.slider_height_campaign').length ){
		sameHeightSliders($('.slider_height_campaign'));
	}

	if ($(w).width() > 951) {
		$('div[data-index]').on('mouseenter', toggleGallery);
	} else {
		$('div[data-index]').off('mouseenter', toggleGallery);
	}

	if( $('#people_toggle').length ){
		$('.people-template__columns-block-title').css('height', 'auto');
		if ($(w).width() > 951) {
			$('.columns_module_toggle .grid.grid--col-2-people').each(function() {
				setEqualHeight(this);
			});
		}
	}
});

function toggleGallery(event) {
	let index = $(this).data('index');
	let target = $('#gallery_markets').find(`div[data-index-gallery=${index}]`);
	let prev_index = $('#markets_main').find(`div[data-index].active`);
	let number = $(prev_index).data('index');
	let prev_target = $('#gallery_markets').find(`div[data-index-gallery=${number}]`);
	
	if (target.length && index != number) {
		$(prev_index).removeClass('active');
		$(this).addClass('active');
		$(target).fadeIn(200).addClass('active');
		$(prev_target).fadeOut(50).removeClass('active');
	}
}

function toggleCard(container) {
	let lastItem;
	$(container).on('click', '.toggle_trigger', function() {
		let currentItem = $(this).parent();
		let currentState = currentItem.attr('data-state');
		let scrollOffset = 85;

		if (currentState === "open") {
			currentItem.data('state', 'close');
			currentItem.attr('data-state', 'close');
			$(this).siblings('.toggle_target').slideUp('fast').removeClass('active');
		} else {
			lastItem = $(container).find('.toggle_container[data-state="open"]');
			if (lastItem.length) {
				lastItem.data('state', 'close');
				lastItem.attr('data-state', 'close');
				lastItem.children('.toggle_target').slideUp('fast').removeClass('active');
			}

			currentItem.data('state', 'open');
			currentItem.attr('data-state', 'open');
			$(this).siblings('.toggle_target').slideDown('slow', function() {
				$('html, body').animate({
					scrollTop: currentItem.offset().top - scrollOffset
				}, 600);
			}).toggleClass('active');
		}
	});
}

// Función para igualar alturas entre títulos del mismo bloque
function setEqualHeight(container) {
	$(container).each(function() {
		let titles = $(this).find('.people-template__columns-block-title');
		let maxHeight = 0;
		
		// Comparar alturas y encontrar la máxima
		titles.each(function() {
			let thisHeight = $(this).outerHeight();
			if (thisHeight > maxHeight) {
				maxHeight = thisHeight;
			}
		});

		// Aplicar la altura máxima encontrada
		titles.css('height', maxHeight + 'px');
	});
}

const fetch_afas = (search_term, state_filter) => {
	$.ajax({
		type: 'POST',
		dataType: 'html',
		url: cltvo_js_vars.ajax_url,
		data: { 
			action : 'directory', 
			search: search_term,
			state: state_filter,
		},
		success: function(data){
			$('#afas_directory').empty();
			$('#afas_directory').html(data);
			$('.block_afa_trigger').on('click', function(){
				$(this).toggleClass('active');
				$(this).siblings('.block_afa_target').slideToggle(300);
			});
		},
		error: function(errors){
			console.log( errors );
		}
	});
}



//Scroll en links de misma página
$('a[href*="#"]')
.not('[href="#"]')
.not('[href="#0"]')
.click(function(event) {
	if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
		let target = $(this.hash);
		target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

		if (target.length) {
			event.preventDefault();
			$('html, body').animate({
				scrollTop: target.offset().top - 120
			}, 1000);
		}
	}
});

//AFAS Blog
let primeraCarga = true;
let tipoActivo = $('#archive_afas_filters .afas-blog-archive__grid-filters-block.active').data('type-filter') || 'all';

function cargarArticulos(tipoActivo, paged = 1) {
	console.log(tipoActivo);
	$.ajax({
		type: 'POST',
		dataType: 'html',
		url: cltvo_js_vars.ajax_url,
		data: {
			action: 'load_afas_blog',
			tipo: tipoActivo,
			paged: paged
		},
		beforeSend: function() {
			$('#grid_container_afas').addClass('loading');
		},
		success: function(response) {
			$('#grid_container_afas').html(response);
			$('#grid_container_afas').removeClass('loading');
			igualarAlturasArticulosGrid();
			viewerVideo();
			if (!primeraCarga) {
				$('html, body').animate({
					scrollTop: $('#grid-wrapper-afas').offset().top - 170
				}, 400);
			}

			primeraCarga = false;
		},
		error: function(xhr) {
			console.error('Error al cargar eventos:', xhr);
		}
	});
}

// Click en paginador (números)
$(document).on('click', '.afas-blog-archive__grid-pagination a.page-num', function(e) {
	e.preventDefault();
	const paged = $(this).data('page');
	if (paged) {
		cargarArticulos(tipoActivo, paged);
	}
});

// Botón anterior / siguiente
$(document).on('click', '.btn--prev, .btn--next', function(e) {
	e.preventDefault();
	if ($(this).hasClass('disabled')) return;
	const paged = $(this).data('page');
	if (paged) {
		cargarArticulos(tipoActivo, paged);
	}
});

// Click en filtro de tipo (all / webinar)
$('.afas-blog-archive__grid-filters-block').on('click', function() {
	$('.afas-blog-archive__grid-filters-block').removeClass('active');
	$(this).addClass('active');

	tipoActivo = $(this).data('type-filter');
	cargarArticulos(tipoActivo, 1); // Reinicia paginador
});

//Alturas cards Artículos
function igualarAlturasArticulosGrid() {
	if (window.innerWidth <= 950) return; 
	
	const clases = ['.upper-container', '.expert-container', '.data-container'];

	clases.forEach(function(clase) {
		// Reinicia alturas
		$('.event_grid_block ' + clase).css('height', 'auto');

		// Agrupar en pares (2 columnas por fila)
		let items = $('.event_grid_block');
		for (let i = 0; i < items.length; i += 2) {
			let $rowItems = items.slice(i, i + 2); // grupo de A-B, C-D, etc.
			let maxHeight = 0;

			$rowItems.find(clase).each(function() {
				let altura = $(this).outerHeight();
				if (altura > maxHeight) maxHeight = altura;
			});

			$rowItems.find(clase).height(maxHeight);
		}
	});
}
